const translations: Record<string, string> = {
  "ak_prices_uah_mwh_vs": "грн/МВт·год · {{ym}} vs {{prev}}",
  "ak_prices_hour_00": "Година {{h}}:00",
  "ak_prices_positive_imbalance_uah_mwh": "ПНБ: {{v}} грн/МВт·год",
  "ak_prices_negative_imbalance_uah_mwh": "ННБ: {{v}} грн/МВт·год",
  "ak_prices_no_imbalance_prices_for": "Немає цін небалансів за {{d}}.",
  "ak_prices_no_dam_data_for": "Немає даних РДН за {{d}}.",
  "ak_prices_prices_for_tomorrow_appear_today_at_12": "Ціни на завтра зʼявляються сьогодні о 12:45–13:15 за київським часом.",
  "ak_prices_uah_mwh": "{{n}} грн/МВт·год",
  "ak_prices_mwh": "{{n}} МВт·год",
  "ak_prices_data_source_market_operator_jsc": "джерело даних: АТ «Оператор ринку»",
  "ak_prices_source_market_operator_jsc": "джерело: АТ «Оператор ринку»",
  "ak_prices_source_npc_ukrenergo": "джерело: НЕК «Укренерго»",
  "ak_prices_hour": "Година",
  "ak_prices_chart": "Графік",
  "ak_prices_table": "Таблиця",
  "ak_prices_min_positive": "Мін. позитивний",
  "ak_prices_max_positive": "Макс. позитивний",
  "ak_prices_min_negative": "Мін. негативний",
  "ak_prices_max_negative": "Макс. негативний",
  "ak_prices_loading": "Завантаження…",
  "ak_prices_balancing_market_price_uah_mwh": "Ціна Балансуючого ринку, грн/МВт·год",
  "ak_prices_positive_imbalance_uah_mwh_2": "Позитивний небаланс, грн/МВт·год",
  "ak_prices_negative_imbalance_uah_mwh_2": "Негативний небаланс, грн/МВт·год",
  "ak_prices_positive_imbalance": "Позитивний небаланс",
  "ak_prices_negative_imbalance": "Негативний небаланс",
  "ak_prices_price_uah_mwh": "Ціна, грн/МВт·год",
  "ak_prices_volume_mwh": "Обсяг, МВт·год",
  "ak_prices_price": "Ціна",
  "ak_prices_volume": "Обсяг",
  "ak_prices_uah_mwh_vs_d_1": "грн/МВт·год · vs D−1",
  "ak_prices_daily": "За добу",
  "ak_prices_day_8_23": "День (8-23)",
  "ak_prices_night_1_7_24": "Ніч (1-7, 24)",
  "ak_prices_peak_18_23": "Пік (18-23)",
  "ak_prices_semi_peak_8_17": "Напівпік (8-17)",
  "ak_prices_monthly": "За місяць",
  "ak_prices_dam_day_ahead": "РДН (на добу наперед)",
  "ak_prices_bm_operational": "БР — оперативні",
  "ak_prices_bm_actual": "БР — фактичні",
  "ak_prices_market_prices": "Ринок, ціни",
  "ak_prices_weighted_average_dam_prices": "Середньозважені ціни РДН",
  "ak_prices_hourly_dam_prices": "Погодинні ціни РДН",
  "ak_prices_operational_balancing_market_prices": "Оперативні ціни Балансуючого ринку",
  "ak_prices_actual_balancing_market_prices": "Фактичні ціни Балансуючого ринку",
  "ak_prices_actual_hourly_balancing_market_prices": "Фактичні погодинні ціни Балансуючого ринку",
  "ak_prices_operational_hourly_balancing_market_pr": "Оперативні погодинні ціни Балансуючого ринку",
  "ak_prices_prices": "Ціни",
  "ak_prices_no_dam_data": "Немає даних РДН.",
  "ak_prices_prices_for_tomorrow_appear_today_at_12_2": "Ціни на завтра зʼявляються сьогодні о 12:45–13:15.",
};

export default translations;
